export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const inr0 = (n) => "₹" + Math.round(Number(n || 0)).toLocaleString("en-IN");

export const todayIST = (offset = 0) =>
  new Date(Date.now() + 5.5 * 3600e3 + offset * 864e5).toISOString().slice(0, 10);

export const shiftDate = (date, n) => {
  const d = new Date(date + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const fmtDate = (d) =>
  d ? new Date(d.length === 10 ? d + "T00:00:00" : d).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" }) : "";

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : "";

export const itemsText = (items = []) => items.map((i) => `${i.name} × ${i.qty}`).join(", ");

export const portalUrl = (token, tab = "") => `${window.location.origin}/c/${token}${tab ? "/" + tab : ""}`;

export const mapsHref = (o) => o.maps_url || (o.lat != null ? `https://www.google.com/maps/search/?api=1&query=${o.lat},${o.lng}`
  : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${o.address || ""} ${o.area || ""}`.trim())}`);

export const waLink = (phone, text) => {
  let p = String(phone || "").replace(/\D/g, "");
  if (p.length === 10) p = "91" + p;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
};

export const msgs = {
  order: (c, date, biz) =>
    `Namaste ${c.name} 🙏\nThis is ${biz}. Do you need fresh batter tomorrow (${fmtDate(date)})?\n\nTap the link to choose product & quantity, or say no for tomorrow:\n${portalUrl(c.token, "order")}`,
  delivery: (c, biz) =>
    `Hi ${c.name}, your fresh batter from ${biz} has been delivered ✅\nPlease tap to see the delivery photo and confirm you received it:\n${portalUrl(c.token, "deliveries")}`,
  payment: (c, bal, biz) =>
    `Hi ${c.name}, your ${biz} batter bill outstanding is ${inr(bal)}.\nView your weekly statement & pay instantly via UPI (GPay / PhonePe / Paytm):\n${portalUrl(c.token, "pay")}\nThank you 🙏`,
};
